export default __webpack_public_path__ + "static/media/Decayer Gloves.7186bd95.jpg";